/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { Checkbox, Icon } from "@mui/material";
import MDButton from "components/MDButton";

export default function TableData() {


    const formTemplateRows = (data, selTempl) => {
        let rows = [];

        if (selTempl) {
            for (let rs in data) {
                let row = {
                    from: rs == 0 ? 0 : selTempl.calculation[rs - 1],
                    to: (rs == selTempl.calculation.length) ? "Above" : selTempl.calculation[rs],
                    uom: "Kg",
                    rate: data[rs],
                    per: <Checkbox defaultChecked={(rs != selTempl.calculation.length) ? selTempl.config[rs] : true} disabled />,

                }
                rows.push(row);
            }
        }
        return rows;
    }

    return {
        formTemplateRows,
        templateHeaders: [
            { Header: "From", accessor: "from", align: "center" },
            { Header: "To", accessor: "to", align: "center" },
            { Header: "Rate", accessor: "rate", align: "center" },
            { Header: "Per Kg", accessor: "per", align: "center" }
        ],

    };
}
